import TextField from "@material-ui/core/TextField";
import React from "react";
import CcFieldLayout, {
  resolveFieldMessage,
  useCcInputStyles,
} from "./CcFieldLayout";

const CcTextField = React.forwardRef(
  (
    {
      label,
      required = false,
      helperText,
      hint,
      error,
      id,
      fullWidth = true,
      variant = "outlined",
      margin = "none",
      InputLabelProps: _inputLabelProps,
      FormHelperTextProps: _formHelperTextProps,
      className,
      inputClassName,
      ...props
    },
    ref,
  ) => {
    const inputClasses = useCcInputStyles();
    const { hasError, message } = resolveFieldMessage({
      error,
      helperText,
      hint,
    });

    const input = (
      <TextField
        ref={ref}
        id={id}
        fullWidth={fullWidth}
        variant={variant}
        margin={margin}
        required={required}
        error={hasError}
        helperText={undefined}
        label={undefined}
        className={`cc-input ${inputClasses.root}${inputClassName ? ` ${inputClassName}` : ""}`}
        InputLabelProps={{ shrink: false, style: { display: "none" } }}
        FormHelperTextProps={{ style: { display: "none" } }}
        {...props}
      />
    );

    if (!label && !message) {
      return input;
    }

    return (
      <CcFieldLayout
        label={label}
        required={required}
        error={hasError ? message : undefined}
        hint={!hasError ? message : undefined}
        htmlFor={id}
        className={className}
      >
        {input}
      </CcFieldLayout>
    );
  },
);

CcTextField.displayName = "CcTextField";

export default CcTextField;
